import { render, staticRenderFns } from "./Skin.vue?vue&type=template&id=09e1c5bd&scoped=true&"
import script from "./Skin.vue?vue&type=script&lang=js&"
export * from "./Skin.vue?vue&type=script&lang=js&"
import style0 from "./Skin.vue?vue&type=style&index=0&id=09e1c5bd&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e1c5bd",
  null
  
)

export default component.exports